export const normalizeBirthNumber = (value: string) =>
	value.replace(/[\s/]/g, "");
